import React, { ReactNode } from 'react';

interface StatCardProps {
    title: string;
    value: string | number;
    icon: ReactNode;
    change?: {
        value: string | number;
        type: 'increase' | 'decrease';
    };
    className?: string;
}

const StatCard: React.FC<StatCardProps> = ({
                                               title,
                                               value,
                                               icon,
                                               change,
                                               className = '',
                                           }) => {
    return (
        <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
            <div className="flex items-center">
                <div className="p-3 rounded-full bg-blue-100 text-blue-600">
                    {icon}
                </div>
                <div className="ml-5">
                    <p className="text-sm font-medium text-gray-500 truncate">{title}</p>
                    <p className="mt-1 text-3xl font-semibold text-gray-900">{value}</p>
                </div>
            </div>
            {change && (
                <div className="mt-4">
                    <div
                        className={`inline-flex items-center text-sm font-medium ${
                            change.type === 'increase'
                                ? 'text-green-600'
                                : 'text-red-600'
                        }`}
                    >
                        {change.type === 'increase' ? '↑' : '↓'} {change.value}
                    </div>
                    <span className="text-sm font-medium text-gray-500 ml-1">from previous period</span>
                </div>
            )}
        </div>
    );
};

export default StatCard;